import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from "@angular/core";
import { CommonModule } from "@angular/common";
import { NbAuthModule, NbDummyAuthStrategy } from "@nebular/auth";
import { NbSecurityModule, NbRoleProvider } from "@nebular/security";
import { of as observableOf } from "rxjs";

import { throwIfAlreadyLoaded } from "./module-import-guard";
import {
  AnalyticsService,
  LayoutService,
  PlayerService,
  StateService,
  ExportService
} from "./utils";

import { UserData } from "./data/users";
import { UserService } from "./api/users.service";

import { GroupData } from "./data/group";
import { GroupService } from "./api/group.service";

import { EmailData } from "./data/email";
import { EmailService } from "./api/email.service";

import { FormData } from "./data/form";
import { FormService } from "./api/form.service";


import { FlussoData } from "./data/flusso";
import { FlussoService } from "./api/flusso.service";

import { CampaignData } from "./data/campaign";
import { CampaignProjectService } from "./api/campaign-project.service";

import { CampaignFinanceData } from "./data/campaignFinance";
import { CampaignFinanceService } from "./api/campaignFinance.service";

import { LeadData } from "./data/lead";
import { LeadService } from "./api/lead.service";

import { LeadFinanceData } from "./data/leadFinance";
import { LeadFinanceService } from "./api/leadFinance.service";

import { OfferData } from "./data/offer";
import { OfferService } from "./api/offer.service";

import { StatisticData } from "./data/statistics";
import { StatisticService } from "./api/statistics.service";

import { AlertData } from "./data/alert";
import { AlertService } from "./api/alert.service";

import { NotificationData } from "./data/notification";
import { NotificationService } from "./api/notification.service";

import { ApiModule } from "./api/api.module";
import { ChatService } from "./api/chat.service";
import { ChatData } from "./data/chat";

const socialLinks = [
  {
    url: "https://github.com/akveo/nebular",
    target: "_blank",
    icon: "github",
  },
  {
    url: "https://www.facebook.com/akveo/",
    target: "_blank",
    icon: "facebook",
  },
  {
    url: "https://twitter.com/akveo_inc",
    target: "_blank",
    icon: "twitter",
  },
];

const DATA_SERVICES = [
  { provide: UserData, useClass: UserService },
  { provide: ChatData, useClass: ChatService },
  { provide: GroupData, useClass: GroupService },
  { provide: EmailData, useClass: EmailService },
  { provide: FormData, useClass: FormService },
  { provide: LeadData, useClass: LeadService },
  { provide: LeadFinanceData, useClass: LeadFinanceService },
  { provide: FlussoData, useClass: FlussoService },
  { provide: CampaignData, useClass: CampaignProjectService },
  { provide: CampaignFinanceData, useClass: CampaignFinanceService },
  { provide: OfferData, useClass: OfferService },
  { provide: StatisticData, useClass: StatisticService },
  { provide: AlertData, useClass: AlertService },
  { provide: NotificationData, useClass: NotificationService },
];

export class NbSimpleRoleProvider extends NbRoleProvider {
  getRole() {
    // here you could provide any role based on any auth flow
    return observableOf("guest");
  }
}

export const NB_CORE_PROVIDERS = [
  ...ApiModule.forRoot().providers,
  ...DATA_SERVICES,
  ...NbAuthModule.forRoot({
    strategies: [
      NbDummyAuthStrategy.setup({
        name: "email",
        delay: 3000,
      }),
    ],
    forms: {
      login: {
        socialLinks: socialLinks,
      },
      register: {
        socialLinks: socialLinks,
      },
    },
  }).providers,

  NbSecurityModule.forRoot({
    accessControl: {
      guest: {
        view: "*",
      },
      user: {
        parent: "guest",
        create: "*",
        edit: "*",
        remove: "*",
      },
    },
  }).providers,

  {
    provide: NbRoleProvider,
    useClass: NbSimpleRoleProvider,
  },
  AnalyticsService,
  LayoutService,
  PlayerService,
  StateService,
  ExportService
];

@NgModule({
  imports: [CommonModule],
  exports: [NbAuthModule],
  declarations: [],
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, "CoreModule");
  }

  static forRoot(): ModuleWithProviders {
    return <ModuleWithProviders>{
      ngModule: CoreModule,
      providers: [...NB_CORE_PROVIDERS],
    };
  }
}
